const $d849a25435f2e5fc$var$ones = {
    '0': "\u043D\u04E9\u043B",
    '1': "\u0431\u0456\u0440",
    '2': "\u0435\u043A\u0456",
    '3': "\u04AF\u0448",
    '4': "\u0442\u04E9\u0440\u0442",
    '5': "\u0431\u0435\u0441",
    '6': "\u0430\u043B\u0442\u044B",
    '7': "\u0436\u0435\u0442\u0456",
    '8': "\u0441\u0435\u0433\u0456\u0437",
    '9': "\u0442\u043E\u0493\u044B\u0437"
};
const $d849a25435f2e5fc$var$tens = {
    '10': "\u043E\u043D",
    '20': "\u0436\u0438\u044B\u0440\u043C\u0430",
    '30': "\u043E\u0442\u044B\u0437",
    '40': "\u049B\u044B\u0440\u044B\u049B",
    '50': "\u0435\u043B\u0443",
    '60': "\u0430\u043B\u043F\u044B\u0441",
    '70': "\u0436\u0435\u0442\u043F\u0456\u0441",
    '80': "\u0441\u0435\u043A\u0441\u0435\u043D",
    '90': "\u0442\u043E\u049B\u0441\u0430\u043D"
};
const $d849a25435f2e5fc$var$transcriptions = {
    "\u043D\u04E9\u043B": "\u043D\u0451\u043B",
    "\u0431\u0456\u0440": "\u0431\u044B\u0440",
    "\u0435\u043A\u0456": "\u0435-\u043A\u044B",
    "\u04AF\u0448": "\u0443\u0448",
    "\u0442\u04E9\u0440\u0442": "\u0442\u0451\u0440\u0442",
    "\u0431\u0435\u0441": "\u0431\u0435\u0441",
    "\u0430\u043B\u0442\u044B": "\u0430\u043B-\u0442\u044B",
    "\u0436\u0435\u0442\u0456": "\u0436\u0435-\u0442\u044B",
    "\u0441\u0435\u0433\u0456\u0437": "\u0441\u0435-\u0433\u044B\u0437",
    "\u0442\u043E\u0493\u044B\u0437": "\u0442\u043E-\u0433\u044B\u0437",
    "\u043E\u043D": "\u043E\u043D",
    "\u0436\u0438\u044B\u0440\u043C\u0430": "\u0436\u044B-\u0439\u044B\u0440-\u043C\u0430",
    "\u043E\u0442\u044B\u0437": "\u043E-\u0442\u044B\u0437",
    "\u049B\u044B\u0440\u044B\u049B": "\u043A\u044B-\u0440\u044B\u043A",
    "\u0435\u043B\u0443": "\u0435-\u043B\u044E",
    "\u0430\u043B\u043F\u044B\u0441": "\u0430\u043B-\u043F\u044B\u0441",
    "\u0436\u0435\u0442\u043F\u0456\u0441": "\u0436\u0435\u0442-\u043F\u044B\u0441",
    "\u0441\u0435\u043A\u0441\u0435\u043D": "\u0441\u0435\u043A-\u0441\u0435\u043D",
    "\u0442\u043E\u049B\u0441\u0430\u043D": "\u0442\u043E\u043A-\u0441\u0430\u043D",
    "\u0436\u04AF\u0437": "\u0436\u044E\u0437"
};
function $d849a25435f2e5fc$export$e31112066210c639(text) {
    return text.split(' ').map((word)=>$d849a25435f2e5fc$var$transcriptions[word] || word).join(' ');
}
function $d849a25435f2e5fc$export$41734553b1dd70f0(chunk) {
    if (!chunk) return '';
    if (chunk.length === 1) return $d849a25435f2e5fc$var$ones[chunk];
    if (chunk.length === 2) {
        if (chunk === '00') return "\u043D\u04E9\u043B \u043D\u04E9\u043B";
        if (chunk[0] === '0') return "\u043D\u04E9\u043B " + $d849a25435f2e5fc$var$ones[chunk[1]];
        if (chunk[1] === '0') return $d849a25435f2e5fc$var$tens[chunk];
        return $d849a25435f2e5fc$var$tens[chunk[0] + '0'] + ' ' + $d849a25435f2e5fc$var$ones[chunk[1]];
    }
    if (chunk.length === 3) {
        if (chunk === '000') return "\u043D\u04E9\u043B \u043D\u04E9\u043B \u043D\u04E9\u043B";
        const parts = [];
        if (chunk[0] !== '0') parts.push(chunk[0] === '1' ? "\u0436\u04AF\u0437" : $d849a25435f2e5fc$var$ones[chunk[0]] + " \u0436\u04AF\u0437");
        else parts.push("\u043D\u04E9\u043B");
        if (chunk[1] !== '0') {
            parts.push($d849a25435f2e5fc$var$tens[chunk[1] + '0']);
            if (chunk[2] !== '0') parts.push($d849a25435f2e5fc$var$ones[chunk[2]]);
        } else if (chunk[2] !== '0') {
            if (chunk[0] === '0') parts.push("\u043D\u04E9\u043B");
            parts.push($d849a25435f2e5fc$var$ones[chunk[2]]);
        }
        return parts.join(' ');
    }
    if (chunk.length === 4) return $d849a25435f2e5fc$export$41734553b1dd70f0(chunk.slice(0, 2)) + ' ' + $d849a25435f2e5fc$export$41734553b1dd70f0(chunk.slice(2, 4));
    return '';
}
function $d849a25435f2e5fc$export$98f6ffead66e49fe(code) {
    if (!code) return [];
    if (code.length === 16) return [
        code.slice(0, 4),
        code.slice(4, 8),
        code.slice(8, 12),
        code.slice(12, 16)
    ];
    if (code.length === 11 && /^[78]/.test(code)) return [
        code.slice(0, 1),
        code.slice(1, 4),
        code.slice(4, 7),
        code.slice(7, 9),
        code.slice(9, 11)
    ];
    if (code.length === 10 && /^7/.test(code)) return [
        code.slice(0, 3),
        code.slice(3, 6),
        code.slice(6, 8),
        code.slice(8, 10)
    ];
    if (code.length === 4) return [
        code.slice(0, 2),
        code.slice(2, 4)
    ];
    const matches = code.match(/([1-9]00|\d{2}|\d)/g);
    return matches || [];
}


const $35da740d59af89ba$var$inputEl = document.getElementById('code-input');
const $35da740d59af89ba$var$clearBtn = document.getElementById('clear-btn');
const $35da740d59af89ba$var$emptyState = document.getElementById('empty-state');
const $35da740d59af89ba$var$tagsGrid = document.getElementById('tags-grid');
const $35da740d59af89ba$var$resultContainer = document.getElementById('result-container');
const $35da740d59af89ba$var$resultText = document.getElementById('result-text');
const $35da740d59af89ba$var$transcriptionText = document.getElementById('transcription-text');
const $35da740d59af89ba$var$copyBtn = document.getElementById('copy-btn');
const $35da740d59af89ba$var$copyIcon = document.getElementById('copy-icon');
const $35da740d59af89ba$var$copyTextEl = document.getElementById('copy-text');
const $35da740d59af89ba$var$svgCopy = `<svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>`;
const $35da740d59af89ba$var$svgCheck = `<svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
const $35da740d59af89ba$var$copyBtnDefaultClass = 'copy-btn-base flex-shrink-0 w-full sm:w-auto bg-surface-card text-primary-800 border-2 border-primary-200 hover:bg-primary-50 hover:border-primary-300 active:scale-[0.98] shadow-sm touch-manipulation';
const $35da740d59af89ba$var$copyBtnSuccessClass = 'copy-btn-base flex-shrink-0 w-full sm:w-auto bg-primary-100 text-primary-800 border-2 border-primary-300 shadow-sm touch-manipulation';
let $35da740d59af89ba$var$currentJoinedText = '';
function $35da740d59af89ba$var$formatDisplayValue(raw) {
    if (!raw) return '';
    if (raw.length === 16) return raw.replace(/(\d{4})(?=\d)/g, '$1 ');
    if (raw.length === 11 && /^[78]/.test(raw)) return raw.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/, '$1 $2 $3 $4 $5');
    if (raw.length === 10 && raw[0] === '7') return raw.replace(/^(\d{3})(\d{3})(\d{2})(\d{2})$/, '$1 $2 $3 $4');
    return raw;
}
function $35da740d59af89ba$var$render() {
    const rawVal = $35da740d59af89ba$var$inputEl.value.replace(/\D/g, '');
    $35da740d59af89ba$var$inputEl.value = $35da740d59af89ba$var$formatDisplayValue(rawVal);
    if (rawVal.length > 0) {
        $35da740d59af89ba$var$clearBtn.classList.remove('hidden');
        $35da740d59af89ba$var$emptyState.classList.add('hidden');
        $35da740d59af89ba$var$tagsGrid.classList.remove('hidden');
        $35da740d59af89ba$var$tagsGrid.classList.add('flex');
        $35da740d59af89ba$var$resultContainer.classList.remove('hidden');
        $35da740d59af89ba$var$resultContainer.classList.add('flex');
        const chunks = (0, $d849a25435f2e5fc$export$98f6ffead66e49fe)(rawVal);
        $35da740d59af89ba$var$tagsGrid.innerHTML = chunks.map((chunk)=>{
            const kaz = (0, $d849a25435f2e5fc$export$41734553b1dd70f0)(chunk);
            const trans = (0, $d849a25435f2e5fc$export$e31112066210c639)(kaz);
            return `
                <div class="chunk-card">
                    <span class="text-lg sm:text-xl font-bold text-primary-800 font-mono tracking-wider">${chunk}</span>
                    <span class="text-xs sm:text-sm font-semibold text-primary-800 mt-1 text-center whitespace-nowrap leading-tight">${kaz}</span>
                    <span class="text-[10px] sm:text-xs text-primary-500/90 italic mt-0.5 text-center leading-tight">${trans}</span>
                </div>
            `;
        }).join('');
        $35da740d59af89ba$var$currentJoinedText = chunks.map((0, $d849a25435f2e5fc$export$41734553b1dd70f0)).join(', ');
        const joinedTranscription = chunks.map((c)=>(0, $d849a25435f2e5fc$export$e31112066210c639)((0, $d849a25435f2e5fc$export$41734553b1dd70f0)(c))).join(', ');
        $35da740d59af89ba$var$resultText.textContent = $35da740d59af89ba$var$currentJoinedText;
        $35da740d59af89ba$var$transcriptionText.textContent = `[ ${joinedTranscription} ]`;
    } else {
        $35da740d59af89ba$var$clearBtn.classList.add('hidden');
        $35da740d59af89ba$var$emptyState.classList.remove('hidden');
        $35da740d59af89ba$var$tagsGrid.classList.add('hidden');
        $35da740d59af89ba$var$tagsGrid.classList.remove('flex');
        $35da740d59af89ba$var$resultContainer.classList.add('hidden');
        $35da740d59af89ba$var$resultContainer.classList.remove('flex');
        $35da740d59af89ba$var$tagsGrid.innerHTML = '';
        $35da740d59af89ba$var$currentJoinedText = '';
    }
    $35da740d59af89ba$var$resetCopyButton();
}
function $35da740d59af89ba$var$resetCopyButton() {
    $35da740d59af89ba$var$copyBtn.className = $35da740d59af89ba$var$copyBtnDefaultClass;
    $35da740d59af89ba$var$copyIcon.innerHTML = $35da740d59af89ba$var$svgCopy;
    $35da740d59af89ba$var$copyTextEl.textContent = "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C";
}
$35da740d59af89ba$var$inputEl.addEventListener('input', $35da740d59af89ba$var$render);
$35da740d59af89ba$var$clearBtn.addEventListener('click', ()=>{
    $35da740d59af89ba$var$inputEl.value = '';
    $35da740d59af89ba$var$render();
    $35da740d59af89ba$var$inputEl.focus();
});
$35da740d59af89ba$var$copyBtn.addEventListener('click', ()=>{
    if (!$35da740d59af89ba$var$currentJoinedText) return;
    const textArea = document.createElement("textarea");
    textArea.value = $35da740d59af89ba$var$currentJoinedText;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    $35da740d59af89ba$var$copyBtn.className = $35da740d59af89ba$var$copyBtnSuccessClass;
    $35da740d59af89ba$var$copyIcon.innerHTML = $35da740d59af89ba$var$svgCheck;
    $35da740d59af89ba$var$copyTextEl.textContent = "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E";
    setTimeout($35da740d59af89ba$var$resetCopyButton, 2000);
});


//# sourceMappingURL=qazaqsha-soyle.2e310964.js.map
